var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6 col-lg-7 col-md-9 mx-auto"
  }, [_c('h3', [_vm._v("Xert Authentication")]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitHandler();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Username")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.username,
      expression: "form.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "placeholder": "Enter Username",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.username
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "username", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Enter Password",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value);
      }
    }
  })]), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('button', {
    staticClass: "btn-universal cursor-pointer",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Connect ")]), _c('button', {
    staticClass: "btn-universal btn-register-cancel cursor-pointer ml-3",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" Cancel ")])]), _vm._m(0)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mt-3"
  }, [_vm._v(" If you don't have an account, you can create one. "), _c('a', {
    attrs: {
      "href": "https://xertonline.com/auth",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(". and come back here to connect. ")]);
}]

export { render, staticRenderFns }